<template>
  <navbar />
  <router-view></router-view>
  <QuickSearch />
</template>

<script>
import navbar from './components/layout/navbar.vue'
import QuickSearch from "@/components/reservation/QuickSearch.vue";

export default {
  name: 'App',
  components: {
    QuickSearch,
    navbar
  }
}
</script>
